import { BACKEND_URL } from '../config/api';

/**
 * Get the full image URL - handles both local and Firebase Storage URLs
 * @param {string|null} imageUrl - Image URL from database (can be local path or Firebase URL)
 * @returns {string|null} Full image URL or null
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  // If already an absolute URL (Firebase Storage), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // If local path (starts with /), prepend BACKEND_URL
  if (imageUrl.startsWith('/')) {
    return `${BACKEND_URL}${imageUrl}`;
  }

  // Fallback: treat as local path
  return `${BACKEND_URL}/${imageUrl}`;
};

/**
 * Check if an image URL is a Firebase Storage URL
 * @param {string|null} imageUrl - Image URL to check
 * @returns {boolean} True if Firebase URL
 */
export const isFirebaseUrl = (imageUrl) => {
  if (!imageUrl) return false;
  return (
    imageUrl.includes('storage.googleapis.com') ||
    imageUrl.includes('firebasestorage.googleapis.com')
  );
};
